import { get_token,get_user_details } from "@/router";
import Swal from 'sweetalert2';
const GLOBAL_URL = process.env.VUE_APP_BACKEND_API_URL;
const default_user_img = 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/user.webp';
import { view_profile as view_profile_helper } from "@/views/Feed/feed_helper.js";
export default {
  props: {
    comments: {
      type: Array,
      required: true
    },
    activeProfile: {
      type: Object,
      required: false
    }
  },
  data() {
   return ({
    show_comment_like:false,
    selectedCommentLikes: [],
     comments_data: [],
     comment_replies_map: {},
     visible_replies_map: {},
    showAllComments: false,
    showReplyInput: {},
    replyTexts: {},
    headers: {},
    editing_comment_id: null,
    editing_comment_text: "",
    user_id:null,
    token_exists: false,
    user_details: {
                "user_role": '',
                "first_name": '',
                "last_name": '',
            },

    likesModalInstance: null,
    default_user_img: default_user_img,

   });
  },
  watch: {
    comments(newVal) {
      this.comments_data = [...newVal];
    }
  },
  mounted(){
    this.comments_data = Array.isArray(this.comments) ? [...this.comments] : [];
    this.token_exists = get_token();
    this.user_id = this.get_user_id();
    this.user_details=get_user_details();
  this.headers = {
            'Content-Type': 'application/json',
            Authorization: `Token ${get_token()}`
        };

  },
  computed: {
    limitedComments() {
      return this.showAllComments
        ? this.comments_data
        : this.comments_data.slice(0, 3);
    }
},
  methods:{

    view_company(comment) {
      view_profile_helper(this.$router, comment?.base_profile?.company);

    },
    view_profile(user_id) {
      view_profile_helper(this.$router, { id: user_id });

    },
  selectedReport(comment) {
    // Set which comment is selected
    this.selectedLikesCommentId = comment.id;

    // Fetch updated likes from server before opening modal
    $.ajax({
      url: `${GLOBAL_URL}/portal_management/get_comment_likes/`,
      method: "GET",
      headers: this.headers,
      data: { comment_id: comment.id },
      success: (response) => {
        if (response.status === "success" && Array.isArray(response.likes)) {
          this.selectedCommentLikes = response.likes;
        } else {
          this.selectedCommentLikes = [];
        }
        // After getting likes, show modal
        this.show_comment_like = true;
        $("#likesModal").modal("show");
      },
      error: (xhr) => {
        console.error("Error fetching likes:", xhr.responseText);
        this.selectedCommentLikes = [];
        // Still open modal even if empty
        this.show_comment_like = true;
        $("#likesModal").modal("show");
      }
    });
  },

toggleCommentLike(comment) {
  $.ajax({
    url: `${GLOBAL_URL}/portal_management/toggle_report_comment_like/`,
    method: "POST",
    headers: {
      ...this.headers,
      "Content-Type": "application/json"
    },
    data: JSON.stringify({ comment_id: comment.id }),
    success: (response) => {
      if (response.status === "success") {
        // Update the comment object locally
        comment.likes_count = response.likes_count;
        comment.user_liked = response.action === "liked";

        // If modal is going to be opened for this comment, update selectedCommentLikes
        if (this.selectedLikesCommentId === comment.id) {
          this.selectedCommentLikes = response.likes || [];
        }
      }
    },
    error: (xhr) => {
      console.error("Error:", xhr.responseText);
      Swal.fire({
        icon: "error",
        title: "Error toggling like",
        text: "Please try again later.",
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    }
  });
},

    highlightTaggedUsers(text) {
    // Wrap @First_Last in a <span> with a class
    if (!text) return "";
    
    // Step 1: Highlight tagged users
    let highlighted = text.replace(/@(\w+_\w+)/g, '<span class="tagged-user">$&</span>');

    // Step 2: Convert URLs to clickable links
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    highlighted = highlighted.replace(urlRegex, function(url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    return highlighted;  },

get_profile_picture(report) {
    const base = report?.base_profile;

    if (base?.profile_type === 'personal') {
        // PERSONAL PATH
        const files = base?.user?.profile?.profile_files;
        const pic = files?.find(f => f.profile_file_type === 'profile_picture');
        return pic?.file?.url || this.default_user_img;
    }
    
    if (base?.profile_type === 'business') {
        // BUSINESS PATH
        // Your data shows the logo is inside company -> base_profile -> profile_files
        const company_files = base?.company?.base_profile?.profile_files;
        const logo = company_files?.[0]?.file;
        
        // Priority: 1. file_url (from company) 2. url (fallback) 3. default asset
        return logo?.file_url || logo?.url || this.default_user_img;
    }

    return this.default_user_img;
},
    get_personal_profile_picture(profileFiles) {
      if (!Array.isArray(profileFiles)) {
        return this.default_user_img;
      }
 
      const profile_pic = profileFiles.find(
        file => file.profile_file_type === 'profile_picture'
      );
 
      return profile_pic?.file?.url || this.default_user_img;
    },
  
    get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },
  toggleComments() {
        this.showAllComments = !this.showAllComments;
      },
        getToken() {
            return get_token();
        },
  delete_comment(report_comment_id) {
    $.ajax({
        type: "DELETE",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_comment/?report_comment_id=${report_comment_id}`,
        data: JSON.stringify({ report_comment_id: report_comment_id }),
        contentType: 'application/json',
        headers: this.headers,
        success: (response) => {
            if (response.status === "success") {
                const index = this.comments_data.findIndex(comment => comment.id === report_comment_id);
                if (index !== -1) {
                      this.comments_data.splice(index, 1);
                  }

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed to delete comment",
                    text: response.message || "An error occurred.",
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
            }
        },
        error: (xhr, status, error) => {
            Swal.fire({
                icon: "error",
                title: "Failed to delete comment",
                text: error || "An error occurred.",
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
            });
        }
    });
  },

edit_comment(comment) {
    this.editing_comment_id = comment.id;
    this.editing_comment_text = comment.comment_text;
  },

 save_edit_comment(comment_id) {
    if (!this.editing_comment_text.trim()) {
      Swal.fire({
        icon: "error",
        title: "Comment cannot be empty.",
        timer: 2000,
        showConfirmButton: false,
        position: 'bottom-end',
        toast: true
      });
      return;
    }

    const data = {
      report_comment_id: comment_id,
      comment_text: this.editing_comment_text,
    };

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_report_comment/`,
      headers: this.headers,
      contentType: "application/json",
      data: JSON.stringify(data),
      success: (response) => {
        if (response.status === "success") {
          const updatedComment = this.comments_data.find(c => c.id === comment_id);
          if (updatedComment) {
            updatedComment.comment_text = this.editing_comment_text;
          }
          this.editing_comment_id = null;
          this.editing_comment_text = "";
        }
      },
    });
  },
toggleReplies(commentId) {
  const hasKey = Object.prototype.hasOwnProperty.call(this.visible_replies_map, commentId);
  const currentValue = hasKey ? Reflect.get(this.visible_replies_map, commentId) : false;
  Reflect.set(this.visible_replies_map, commentId, !currentValue);
},
get_comment_replies(comment_id, page_number) {
  const request_data = {
    report_comment_id: comment_id,
    page_number: page_number,
  };

  const request_url = `${GLOBAL_URL}/group_management/retrieve_group_feed_comment_reply/`;

  $.ajax({
    url: request_url,
    method: 'GET',
    headers: this.headers,
    data: request_data,
    success: (response) => {  // arrow function here
      if (response.status === "success") {
        const comment_replies = response.data.replies_data.queryset;

        // Use Reflect to safely set properties
        Reflect.set(this.comment_replies_map, comment_id, comment_replies);

        const currentVisibility = Reflect.get(this.visible_replies_map, comment_id);
        Reflect.set(this.visible_replies_map, comment_id, !currentVisibility);
      }
    },
    complete: () => {  // arrow function here
      this.isLoading = false;
    }
  });
},

toggler_comment_input(comment_id) {
  const container = $(`#reply_container_${comment_id}`);
  container.toggleClass("d-none");

  if (typeof comment_id === 'string' || typeof comment_id === 'number') {
    const hasKey = Object.prototype.hasOwnProperty.call(this.showReplyInput, comment_id);
    const currentValue = hasKey
      ? Reflect.get(this.showReplyInput, comment_id)
      : false;

    if (this.$set) {
      // Vue 2 reactivity requires this.$set, but Reflect.set doesn't trigger reactivity
      this.$set(this.showReplyInput, comment_id, !currentValue);
    } else {
      // Vue 3 or non-reactive fallback
      Reflect.set(this.showReplyInput, comment_id, !currentValue);
    }
  } else {
    console.warn('Invalid comment_id:', comment_id);
  }
},
 submit_reply(comment_id) {

  let reply_text = '';

  if (typeof comment_id === 'string' || typeof comment_id === 'number') {
  const hasKey = Object.prototype.hasOwnProperty.call(this.replyTexts, comment_id);
  reply_text = hasKey ? Reflect.get(this.replyTexts, comment_id) : '';
} else {
  console.warn('Invalid comment_id:', comment_id);
  reply_text = '';
}


  if (!reply_text || reply_text.trim() === "") {
    Swal.fire({
      icon: "error",
      title: "Can't submit an empty reply.",
      timer: 2000,
      showConfirmButton: false,
      position: 'bottom-end',
      toast: true
    });
    return;
  }

  const request_data = {
    reply_text: reply_text,
    comment_id: comment_id,
  };

  const request_url = `${GLOBAL_URL}/group_management/add_group_feed_comment_reply/`;

  $.ajax({
    url: request_url,
    method: 'POST',
    headers: this.headers,
    data: JSON.stringify(request_data),
    success: (response) => {
      if (response.status === "success") {
        const response_data = response.data;
        const comment_data = response_data.comment_data;

        // Find the comment in your list
        const targetComment = this.comments_data.find(c => c.id === comment_id);

        if (targetComment) {
          // Make sure reply_comment exists
          if (!Array.isArray(targetComment.reply_comment)) {
            this.$set(targetComment, 'reply_comment', []); // Vue reactivity
          }

          // Push the new reply into the comment's reply_comment array
          targetComment.reply_comment.push(comment_data);
        }

        // Clear input and hide reply input field
        Reflect.set(this.replyTexts, comment_id, '');
        Reflect.set(this.showReplyInput, comment_id, false);

        // ✅ Force the reply section to be visible
        this.visible_replies_map = {
          ...this.visible_replies_map,
          [comment_id]: true
        };
      }
    },



    complete: () => {
      this.isLoading = false;
    }
  });

  
},

 deleteFeedReply(reply_id) {
            Swal.fire({
              title: 'Are you sure?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!',
              position: 'bottom-end',
              toast: true
            }).then((result) => {
              if (result.isConfirmed) {
                $.ajax({
                  type: "DELETE",
                  url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/delete_group_feed_comment_reply/`,
                  data: JSON.stringify({ reply_id: reply_id }),
                  headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                  },
                  success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                      Swal.fire({
                        title: 'Deleted!',
                        text: 'The reply has been deleted.',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1000,
                        position: 'bottom-end',
                        toast: true
                      }).then(() => {
                        $(`#reply_${reply_id}`).remove();
                    });
                    }
                  }
                });
              }
            });
          },


  }

}
